import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const depositValidator: SchemaItem['x-validator'] = {
  required: true,
  validator(value: { depositValue?: number }) {
    if (isNil(value.depositValue)) {
      return '保证金值不能为空'
    }

    if (value.depositValue <= 0) {
      return '保证金值必须大于0'
    }

    return null
  }
}
